<template>
  <div class="px-6 pt-6 mb-6">
    <div class="flex flex-row justify-between w-full">
      <form >
        <div class="mb-6">
          <label class="">Page Title</label>
          <input v-model="page_title" class="block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
        </div>
        <div class="mb-6">
          <label class="">Twitter Link</label>
          <input v-model="twitter" class="block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
        </div>
        <div class="mb-6">
          <label class="">Instagram Link</label>
          <input v-model="instagram" class="block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
        </div>
        <div class="mb-6">
          <label class="">Support Email</label>
          <input v-model="email_support" class="block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
        </div>
        <div class="mb-6">
          <label class="">Google Link</label>
          <input v-model="google" class="block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
        </div>
        <div class="mb-6">
          <label class="">Facebook Link</label>
          <input v-model="facebook" class="block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
        </div>
        <div class="mb-6">
          <label class="block">Care Lines</label>
          <el-tag
            :key="tag"
            class=""
            v-for="tag in care_lines"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag mt-2"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="mini"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-input>
          <el-button v-else class="button-new-tag mt-2 mb-6" :class="{'ml-2': care_lines.length > 0}" size="small" @click="showInput">+ New Care Line</el-button>
          <div class="mb-6">
            <label class="">About Us</label>
            <ckeditor :editor="editor" v-model="about_us" @ready="onReady"></ckeditor>
          </div>
          <div class="mb-6">
            <label class="">Privacy Policy</label>
            <ckeditor :editor="editor" v-model="privacy_policy" @ready="onReady"></ckeditor>
          </div>
          <div class="mb-6">
            <label class="">Terms & Condition</label>
            <ckeditor :editor="editor" v-model="terms_conditions" @ready="onReady"></ckeditor>
          </div>
          <div class="mb-6">
            <label class="">Return Policy</label>
            <ckeditor :editor="editor" v-model="return_policy" @ready="onReady"></ckeditor>
          </div>
        </div>
      </form>
    </div>
    <el-button @click="update()" type="primary">
      <Spinner v-if="loading" size="small" line-fg-color="#00aba1" line-bg-color="#ccc" style="display: inline-block;"/>
      <span v-if="!loading">Update</span>
    </el-button>
  </div>
</template>

<script>
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import CKEditor from '@ckeditor/ckeditor5-vue';
import Spinner from 'vue-simple-spinner';
import Profile from '../../helper/profile';

export default {
  name: 'Profile',
  data() {
    return {
      loading: false,
      inputVisible: false,
      inputValue: '',
      editor: DecoupledEditor,
    };
  },
  computed: {
    ...Profile,
  },
  components: {
    Spinner,
    ckeditor: CKEditor.component,
  },
  methods: {
    async update() {
      try {
        this.loading = true;
        await this.$store.dispatch('SettingsModule/Config/saveMerchantProfile');
        this.$notify.success({
          title: 'Success',
          message: 'Update was successful',
        });
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    handleInputConfirm() {
      if (this.inputValue !== '') {
        this.care_lines.push(this.inputValue);
        this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'care_lines', payload: this.care_lines });
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    handleClose(tag) {
      this.care_lines.splice(this.care_lines.indexOf(tag), 1);
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'care_lines', payload: this.care_lines });
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement(),
      );
    },
  },
};
</script>

<style scoped lang="scss">
  form {
    flex: 0 1 49%;
    input {
      outline: none;
      border-radius: 4px;
    }
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 200px;
    height: 40px !important;
    vertical-align: bottom;
  }

  .ck.ck-editor__editable_inline{
    border: 1px gray solid !important;
    min-height: 300px !important;
  }
</style>
